//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: File,
      default: undefined,
    },
    labelAction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      file: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.file = newValue
    },
    file(newValue) {
      this.$emit('input', newValue)
    },
  },
}
